import { useEffect } from 'react'
import { Col, Row } from '@evertel/web/ui'
import { useService } from '@evertel/di'
import { Analytics } from '@evertel/analytics'

const Page404 = () => {
    const analytics = useService(Analytics, [])

    useEffect(() => {
        analytics.logView('/404')
    }, [])

    return (
        <Row className="login fadeIn animated">
            <Col
                valign="center"
                align="center"
                style={{ minHeight: '100vh', margin: 'auto', overflow: 'auto', maxWidth: 900 }}
            >
                <img
                    src="/assets/img/doughnut-guy.png"
                    className="pb-3"
                    alt="Evertel Doughnut Guy"
                />
                <h1 style={{ fontSize: '4rem' }}>404</h1>
                <h3 className="pt-3">Oops! Looks like you're lost.</h3>
                <p>The page you are looking for was not found.</p>
            </Col>
        </Row>
    )
}

export default Page404
